import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import { Link } from 'gatsby';

export default function CtaButton(props) {
  const { blok } = props;
  let data = blok;
  if (!blok) {
    data = {
      style: props.style,
      title: props.title,
      url: props.url,
      asset: props.asset,
    };
  }

   const classNames = clsx(
    'inline-block mb-6 lg:mb-16 no-underline',
    data?.style === 'pink' ? 'button-primary' : 'button-tertiary',
  );
  let url;
  let isAssetLink = false;

  if (data?.asset?.filename) {
    url = data.asset.filename;
    isAssetLink = true;
  } else {
    if (!data?.url?.url) {
      url = data?.url?.cached_url;
    } else {
      url = data?.url?.url;
    }

    if (props.url && props.url.filename) {
      url = props.url.filename;
    }

    if (url && !url.startsWith('/') && !url.startsWith('http')) {
      url = `/${url}`;
    }
  }

    // Handle the case where neither url nor asset is present (fallback)
    if (!url) {
      url = '#';
    }

    const isExternalLink = url.startsWith('https://') || url.startsWith('http://');

    const shouldUseAnchor = data?.url?.target || isExternalLink || isAssetLink;

  return (
    shouldUseAnchor ? (
      <a
        {...storyblokEditable(data)}
        href={url}
        title={data?.url?.link_title || undefined}
        target={isExternalLink || isAssetLink ? '_blank' : data?.url?.target}
        className={classNames}
        rel="noreferrer"
      >
        {data.title}
      </a>
    ) : (
      <Link
        {...storyblokEditable(data)}
        to={url}
        title={data?.url?.link_title || undefined}
        className={classNames}
      >
        {data.title}
      </Link>
    )
  );
}
